import { t } from '@lingui/core/macro';
import { NoddiInfoBanner } from 'noddi-ui-web';
import type { NonMemberOwnerNotice } from '../../../utils/stationaryCheckout';

type Props = {
  notice: NonMemberOwnerNotice;
};

/**
 * The car belongs to an organization the customer is not a member of. Only a
 * booking on that organization names it: any signed-in customer can enter any
 * plate, and naming the owner otherwise would reveal it.
 */
export const StationaryNonMemberOwnerNotice = ({ notice }: Props) => {
  const { title, text } = noticeTexts(notice);

  return <NoddiInfoBanner variant='info' title={title} texts={[{ value: text }]} />;
};

const noticeTexts = (notice: NonMemberOwnerNotice): { title: string; text: string } => {
  switch (notice.kind) {
    case 'bookedOnOrganization': {
      const { organizationName } = notice;
      return {
        title: t`Booked on ${organizationName}`,
        text: t`This booking may be booked on ${organizationName}. You can choose.`
      };
    }
    case 'invoice':
      return {
        title: t`Invoice is not available`,
        text: t`This car belongs to an organization that pays by invoice. To book with invoice, you need to be invited to the organization.`
      };
    case 'owner':
      return {
        title: t`This car belongs to an organization`,
        text: t`You are not a member of the organization, so this booking is made in your own name. To book on behalf of the organization, you need to be invited to it.`
      };
  }
};
